/**
 * Radar — taxonomies partagées et helpers d'affichage.
 * Source unique de vérité pour ASYM_META / SECTOR_META / CONTINENT_META.
 */
import {
  Eye, Network, Coins, Cpu, Scale, ShieldCheck, Server, Clock, Zap, GitMerge,
} from "lucide-react";

export const ASYM_META = {
  information:    { label: "Information",    icon: Eye,         color: "#378ADD" },
  reseau:         { label: "Réseau",         icon: Network,     color: "#EF9F27" },
  capital:        { label: "Capital",        icon: Coins,       color: "#1D9E75" },
  technologie:    { label: "Technologie",    icon: Cpu,         color: "#7F77DD" },
  reglementaire:  { label: "Réglementaire",  icon: Scale,       color: "#C26EE7" },
  confiance:      { label: "Confiance",      icon: ShieldCheck, color: "#22D3EE" },
  infrastructure: { label: "Infrastructure", icon: Server,      color: "#A78BFA" },
  temps:          { label: "Temps",          icon: Clock,       color: "#F472B6" },
  execution:      { label: "Exécution",      icon: Zap,         color: "#FACC15" },
  coordination:   { label: "Coordination",   icon: GitMerge,    color: "#FB7185" },
};

export const SECTOR_META = {
  macro:               { label: "Macro",            color: "#378ADD" },
  geopolitique:        { label: "Géopolitique",     color: "#EF4444" },
  reglementaire:       { label: "Réglementaire",    color: "#C26EE7" },
  marches_financiers:  { label: "Marchés fin.",     color: "#1D9E75" },
  tech:                { label: "Tech",             color: "#7F77DD" },
  climat:              { label: "Climat",           color: "#22D3EE" },
  sante:               { label: "Santé",            color: "#F472B6" },
  energie:             { label: "Énergie",          color: "#FACC15" },
  matieres_premieres:  { label: "Mat. premières",   color: "#FB7185" },
  defaut:              { label: "Divers",           color: "#71717a" },
};

export const CONTINENT_META = {
  europe:         { label: "Europe",         flag: "🇪🇺" },
  afrique:        { label: "Afrique",        flag: "🌍" },
  amerique_nord:  { label: "Amérique N.",    flag: "🇺🇸" },
  amerique_sud:   { label: "Amérique S.",    flag: "🇧🇷" },
  asie:           { label: "Asie",           flag: "🌏" },
  moyen_orient:   { label: "Moyen-Orient",   flag: "🕌" },
  oceanie:        { label: "Océanie",        flag: "🇦🇺" },
  monde:          { label: "Monde",          flag: "🌐" },
};

export function KPI({ label, value, accent }) {
  return (
    <div className="noam-card p-3">
      <div className="text-[9px] uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="text-2xl font-bold mt-1" style={{ color: accent }}>{value}</div>
    </div>
  );
}
